import encryptServer from '../request/encryptRequest';

// 售后列表(分页)
export const afterQueryPage = (data = {}) => {
  return encryptServer.post('/xiaozi-xms/wireless/saas/sale/refund/pageList', data);
};

// 采购售后数量统计
export const queryStateInfoBySeller = (data = {}) => {
  return encryptServer.post('/xiaozi-xms/wireless/saas/sale/refund/count', data);
};

// 修改采购售后状态
export const editState = (data = {}) => {
  return encryptServer.post('/xiaozi-xms/wireless/saas/sale/refund/audit', data);
};

// 查看售后详情
export const view = (data = {}) => {
  return encryptServer.post('/xiaozi-xms/wireless/saas/after/view', data);
};

// 退货收货统计
export const queryRefundStateInfo = (data = {}) => {
  return encryptServer.post('/xiaozi-xms/wireless/saas/after/queryRefundStateInfo', data);
};

// 确认退货收货
export const sure = (data = {}) => {
  return encryptServer.post('/xiaozi-xms/wireless/saas/after/sure', data, { timeout: 20000 });
};

// 查看确认收货详情
export const details = (data = {}) => {
  return encryptServer.post('/xiaozi-xms/wireless/saas/after/newDetails', data);
};

export function returnedMaterialList (data) {
  return encryptServer.post('/xiaozi-xms/wireless/saas/after/queryOptMaterialSerialInfosBySeller', data);
}

// 查询运单物流轨迹
export function transportRecords (data) {
  return encryptServer.post('/xiaozi-xmo/wireless/saas/xz/erp/transport/records', data);
}

// 查询快递100物流详情
export function queryKuaiDi100Detail (data = {}) {
  return encryptServer.post('/xiaozi-xmo/wireless/saas/kuaiDi100Record/detail', data);
}

// 增量拉取小紫ERP售后单
export function pullXzErpRefund (data = {}) {
  return encryptServer.post('/xiaozi-xms/wireless/saas/sale/refund/pullXzErpRefund', data, { timeout: 1000 * 60 * 5 });
}

// 售后详情(新)
// export const refundDetail = (data = {}) => {
//   return encryptServer.post('/xiaozi-xms/wireless/saas/sale/refund/detail', data);
// };
